import { motion } from "framer-motion";
import { Search, PenTool, Code2, Rocket } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Search,
    title: "Analisi & Strategia",
    text: "Studio la tua attività, i tuoi concorrenti e i tuoi clienti. Definiamo insieme l'obiettivo del sito.",
  },
  {
    n: "02",
    icon: PenTool,
    title: "UI/UX Design",
    text: "Progetto un design unico, pensato per il tuo brand e ottimizzato per convertire visitatori in clienti.",
  },
  {
    n: "03",
    icon: Code2,
    title: "Sviluppo Code-First",
    text: "Scrivo codice pulito e veloce. Niente temi preconfezionati: il tuo sito è costruito da zero.",
  },
  {
    n: "04",
    icon: Rocket,
    title: "Lancio & Supporto",
    text: "Pubblicazione, ottimizzazione SEO e assistenza continua. Non ti lascio mai solo dopo il lancio.",
  },
];

export const Metodo = () => {
  return (
    <section id="metodo" className="relative py-24 lg:py-32" data-testid="metodo-section">
      <div className="mx-auto max-w-7xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mb-16 max-w-2xl"
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-cyan-400 mb-4">Il Metodo</p>
          <h2 className="font-syne text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
            Dalla prima call al lancio,{" "}
            <span className="text-zinc-500">in 4 mosse.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group relative rounded-2xl border border-white/10 bg-zinc-900/60 p-8 transition-all duration-300 hover:border-cyan-400/40 hover:-translate-y-1"
              data-testid={`metodo-step-${s.n}`}
            >
              <span className="font-mono text-5xl font-medium text-white/8 transition-colors duration-300 group-hover:text-cyan-400/20">
                {s.n}
              </span>
              <div className="mt-6 text-cyan-400">
                <s.icon size={26} />
              </div>
              <h3 className="mt-4 font-syne text-lg font-semibold tracking-tight">{s.title}</h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
